import React, { useCallback,useMemo } from 'react';
import classnames from 'classnames';

import { SORT_DIRECTIONS } from '../common';

import Col from './col';

import classes from '../table.module.css';

export default function Head({
  config,
  showCaret,
  sortColumn,
  sortDirection,
  isMobile,
  onColClick,
}) {
  const data = useMemo(
    () =>
      Object.keys(config).map((name) => ({
        config: config[name],
        name,
      })),
    [config]
  );

  const onClick = (name) => () => onColClick(name, name !== sortColumn ? SORT_DIRECTIONS.ASC : '');

  return (
    <thead>
      <tr className={classnames(classes.headRow, 'table-head-row')}>
        {data.map(({ config, name }, index) => {
          const { isHiddenMobile, columnName, columnNameMobile } = config;

          return (
            <Col
              key={`table-head-col-${name}-${index}`}
              text={isMobile ? columnNameMobile || columnName : columnName}
              sortValue={sortColumn === name && sortDirection}
              showCaret={showCaret}
              isHiddenMobile={isHiddenMobile}
              onClick={onClick(name)}
            />
          );
        })}
      </tr>
    </thead>
  );
}
